module.exports = {
  brand: 'mcom',
  baseAssetsUrl: process.env.NODE_ENV === 'development' ? '/public/images' : 'https://assets.mcomnyapps.net/gift-card-rewards/2026-06/images',
};
